(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-nf-20260916-blog"] && !Shopify.designMode) return;
  try {
    
(() => {
  const TAG = 'surutto-nf-article';
  if (customElements.get(TAG)) return;
  class SuruttoNFArticle extends HTMLElement {
    connectedCallback() {
      if (this._abort) return;
      this._abort = new AbortController();
      const signal = this._abort.signal;
      const on = (element, type, listener, options = {}) => element?.addEventListener(type, listener, { ...options, signal });
      const q = selector => this.querySelector(selector);
      const all = selector => [...this.querySelectorAll(selector)];
      const designMode = this.dataset.designMode === 'true';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (designMode) {
        on(this, 'shopify:block:select', event => {
          const block = event.target.closest('[data-nf-editor-group]');
          if (!block) return;
          all('.nf-editor-selected').forEach(node => node.classList.remove('nf-editor-selected'));
          block.classList.add('nf-editor-selected');
          if (block.matches('details')) block.open = true;
          const target = block.matches('details') ? block : block.firstElementChild;
          target?.scrollIntoView({ behavior: 'auto', block: 'center' });
        });
        on(this, 'shopify:block:deselect', event => event.target.closest('[data-nf-editor-group]')?.classList.remove('nf-editor-selected'));
      }
      const details = all('.nf-275_ details');
      details.forEach(detail => on(detail, 'toggle', () => {
        if (!detail.open) return;
        details.forEach(other => { if (other !== detail) other.open = false; });
        if (detail.getBoundingClientRect().top < 0) detail.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
      }));
      if (!designMode && this.dataset.animations === 'true' && !reducedMotion && 'IntersectionObserver' in window) {
        this._animationObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            const element = entry.target;
            element.classList.add('nf-animated', 'nf-' + element.dataset.animation);
            this._animationObserver.unobserve(element);
          });
        }, { threshold: 0.05 });
        all('[data-animation]').forEach(element => this._animationObserver.observe(element));
      }

    }
    disconnectedCallback() {
      this._abort?.abort();
      this._abort = null;
      this._resize?.disconnect();
      this._animationObserver?.disconnect();
      this._wishlistObserver?.disconnect();
    }
  }
  customElements.define(TAG, SuruttoNFArticle);
})();

(() => {
  const TAG = 'surutto-nf-product';
  if (customElements.get(TAG)) return;
  class SuruttoNFProduct extends HTMLElement {
    connectedCallback() {
      if (this._abort) return;
      this._abort = new AbortController();
      const signal = this._abort.signal;
      const on = (element, type, listener, options = {}) => element?.addEventListener(type, listener, { ...options, signal });
      const q = selector => this.querySelector(selector);
      const all = selector => [...this.querySelectorAll(selector)];
      const cartButtonLabel = this.dataset.addLabel || 'カートに入れる';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const slides = all('[data-nf-media-id]');
      const track = q('[data-nf-slides]');
      const dots = all('[data-nf-go]');
      let slideIndex = 0;
      const markSlide = index => {
        slideIndex = index;
        dots.forEach((dot, i) => {
          dot.classList.toggle('active', i === index);
          if (i === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        slides.forEach((slide, i) => {
          slide.inert = i !== index;
          if (i !== index) slide.querySelectorAll('video').forEach(video => video.pause());
        });
      };
      const showSlide = (index, behavior = 'smooth') => {
        if (!slides.length) return;
        const next = (index + slides.length) % slides.length;
        markSlide(next);
        track.scrollTo({ left: next * track.clientWidth, behavior: reducedMotion ? 'auto' : behavior });
      };
      if (slides.length) {
        q('[data-nf-gallery-controls]')?.removeAttribute('hidden');
        on(q('[data-nf-prev]'), 'click', () => showSlide(slideIndex - 1));
        on(q('[data-nf-next]'), 'click', () => showSlide(slideIndex + 1));
        dots.forEach((dot, i) => on(dot, 'click', () => showSlide(i)));
        on(track, 'scroll', () => {
          if (track.clientWidth) markSlide(Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        }, { passive: true });
        if ('ResizeObserver' in window) {
          this._resize = new ResizeObserver(() => showSlide(slideIndex, 'auto'));
          this._resize.observe(track);
        }
      }
      const form = q('.nf-product-form');
      const data = q('[data-nf-variants]');
      if (!form || !data) return;
      let variants;
      try { variants = JSON.parse(data.textContent); } catch (_) { return; }
      const select = q('[data-nf-variant]');
      const quantity = form.querySelector('[name="quantity"]');
      const fields = all('[data-nf-option-index]');
      const add = q('[data-nf-add]');
      const addLabel = q('[data-nf-add-label]');
      const message = q('[data-nf-message]');
      const cartLink = q('[data-nf-cart-link]');
      let current = variants.find(variant => String(variant.id) === select.value);
      const productId = this.dataset.productId;
      const wishlistSlots = all('[data-nf-wishlist-slot], [data-nf-purchase-apps]');
      const syncWishlist = variant => {
        wishlistSlots.forEach(slot => slot.querySelectorAll('.gw-wl-add-to-wishlist-placeholder').forEach(node => {
          const widgetProductId = node.getAttribute('data-gw-product-id') || node.getAttribute('data-gw-product_id');
          if (widgetProductId && widgetProductId !== productId) return;
          node.classList.toggle('nf-wishlist-unavailable', !variant);
          for (const [attribute, value] of Object.entries({ 'data-gw-product-id': productId, 'data-gw-product_id': productId, 'data-gw-variant-id': variant ? String(variant.id) : '' })) {
            if (node.getAttribute(attribute) !== value) node.setAttribute(attribute, value);
          }
        }));
        const appWishlist = all('[data-nf-purchase-apps] .gw-wl-add-to-wishlist-placeholder').some(node => (node.getAttribute('data-gw-product-id') || node.getAttribute('data-gw-product_id')) === productId);
        q('[data-nf-wishlist-builtin]')?.classList.toggle('nf-wishlist-duplicate', appWishlist);
      };
      if (wishlistSlots.length && 'MutationObserver' in window) {
        this._wishlistObserver = new MutationObserver(() => syncWishlist(current));
        wishlistSlots.forEach(slot => this._wishlistObserver.observe(slot, { childList: true, subtree: true }));
      }
      let adding = false;
      let cartUncertain = false;
      const displayMessage = text => {
        message.textContent = text;
        message.hidden = !text;
      };
      const normalizeQuantity = () => {
        const min = Number(quantity.min) || 1;
        const step = Number(quantity.step) || 1;
        const max = quantity.max === '' ? Infinity : Number(quantity.max);
        let value = Number(quantity.value);
        if (!Number.isFinite(value)) value = min;
        value = min + Math.max(0, Math.floor((value - min) / step)) * step;
        if (value > max) value = min + Math.max(0, Math.floor((max - min) / step)) * step;
        quantity.value = String(value);
        all('[data-nf-quantity]').forEach(button => {
          button.disabled = adding || (Number(button.dataset.nfQuantity) < 0 ? value <= min : value + step > max);
        });
      };
      const syncVariant = (variant, updateMedia = true) => {
        current = variant;
        syncWishlist(variant);
        select.value = variant ? String(variant.id) : '';
        add.disabled = adding || cartUncertain || !variant?.available;
        addLabel.textContent = adding ? '追加中です…' : !variant ? 'この組み合わせはありません' : variant.available ? cartButtonLabel : '売り切れ';
        if (variant) {
          q('[data-nf-price]').innerHTML = variant.price;
          q('[data-nf-compare]').innerHTML = variant.compare || '';
          q('[data-nf-compare]').hidden = !variant.compare;
          quantity.min = String(variant.min);
          quantity.step = String(variant.step);
          if (variant.max == null) quantity.removeAttribute('max');
          else quantity.max = String(variant.max);
          fields.forEach((field, i) => field.querySelectorAll('input').forEach(input => { input.checked = input.value === variant.options[i]; }));
          if (updateMedia) {
            const index = slides.findIndex(slide => slide.dataset.nfMediaId === String(variant.media));
            if (index >= 0) showSlide(index, 'auto');
          }
        }
        normalizeQuantity();
      };
      const requestedId = this.dataset.updateUrl === 'true' ? new URL(window.location.href).searchParams.get('variant') : null;
      const requested = variants.find(variant => String(variant.id) === requestedId);
      syncVariant(requested || current);
      if (fields.length) {
        q('[data-nf-options]').hidden = false;
        q('[data-nf-fallback]').hidden = true;
      }
      fields.forEach(field => on(field, 'change', () => {
        if (adding) return;
        const values = fields.map(item => item.querySelector('input:checked')?.value);
        const variant = variants.find(item => item.options.every((value, i) => value === values[i]));
        syncVariant(variant);
        displayMessage('');
        if (this.dataset.updateUrl === 'true') {
        const url = new URL(window.location.href);
        if (variant) url.searchParams.set('variant', variant.id);
        else url.searchParams.delete('variant');
        window.history.replaceState(window.history.state, '', url);
        }
      }));
      on(select, 'change', () => syncVariant(variants.find(variant => String(variant.id) === select.value)));
      all('[data-nf-quantity]').forEach(button => on(button, 'click', () => {
        normalizeQuantity();
        quantity.value = String(Number(quantity.value) + Number(button.dataset.nfQuantity) * (Number(quantity.step) || 1));
        normalizeQuantity();
      }));
      on(quantity, 'change', normalizeQuantity);
      on(form, 'submit', async event => {
        event.preventDefault();
        if (adding || cartUncertain || !current?.available) return;
        normalizeQuantity();
        if (!form.reportValidity()) return;
        const payload = new FormData(form);
        payload.set('id', String(current.id));
        payload.set('quantity', quantity.value);
        fields.forEach(field => field.querySelectorAll('input').forEach(input => payload.delete(input.name)));
        adding = true;
        displayMessage('');
        add.disabled = true;
        addLabel.textContent = '追加中です…';
        form.setAttribute('aria-busy', 'true');
        fields.forEach(field => { field.disabled = true; });
        quantity.readOnly = true;
        normalizeQuantity();
        try {
          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: payload
          });
          if (!response.ok) {
            let error = {};
            try { error = await response.json(); } catch (_) { /* Keep the generic message. */ }
            cartUncertain = response.status >= 500 || response.status === 422;
            displayMessage((typeof error.description === 'string' ? error.description : 'カートに追加できませんでした。') + (cartUncertain ? ' カートの内容を確認してください。' : ' 商品と数量を確認してください。'));
            cartLink.hidden = false;
            return;
          }
          addLabel.textContent = 'カートに追加されました';
          cartLink.hidden = false;
          cartUncertain = true;
          window.location.assign(this.dataset.cartUrl);
        } catch (_) {
          cartUncertain = true;
          displayMessage('通信結果を確認できませんでした。重複追加を避けるため、カートの内容を確認してから再操作してください。');
          cartLink.hidden = false;
        } finally {
          adding = false;
          form.removeAttribute('aria-busy');
          fields.forEach(field => { field.disabled = false; });
          quantity.readOnly = false;
          if (!cartUncertain) syncVariant(current, false);
          else { add.disabled = true; addLabel.textContent = 'カートを確認してください'; normalizeQuantity(); }
        }
      });
    }
    disconnectedCallback() {
      this._abort?.abort();
      this._abort = null;
      this._resize?.disconnect();
      this._animationObserver?.disconnect();
      this._wishlistObserver?.disconnect();
    }
  }
  customElements.define(TAG, SuruttoNFProduct);
})();

/* Keep the installed Dawn product-info/product-form behavior. Scope its HTML
   refresh to this LP block and send requests using the real parent section ID. */
(() => {
  const TAG = 'surutto-nf-dawn-bridge';
  if (customElements.get(TAG)) return;
  class SuruttoNFDawnBridge extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.onLoaded = () => this.connectProduct();
      this.addEventListener('product-info:loaded', this.onLoaded, { signal: this.controller.signal });
      this.addEventListener('click', event => {
        if (event.target.closest('[data-nf-dawn-retry]') && this.lastRequest) {
          this.info.resetProductFormState();
          this.info.renderProductInfo(this.lastRequest);
        }
      }, { signal: this.controller.signal });
      customElements.whenDefined('product-info').then(() => {
        if (this.isConnected) this.connectProduct();
      });
    }
    connectProduct() {
      const info = this.querySelector('product-info');
      if (!info || !info.buildRequestUrlWithParams || info.__suruttoBridge === this) return;
      this.info = info;
      info.__suruttoBridge = this;
      this.original = {
        build: info.buildRequestUrlWithParams,
        render: info.renderProductInfo,
        quantity: info.fetchQuantityRules,
      };
      info.buildRequestUrlWithParams = (url, options = []) => {
        const request = new URL(url, location.origin);
        if (request.origin !== location.origin) throw new Error('Invalid product URL');
        request.searchParams.set('section_id', this.dataset.parentSection);
        request.searchParams.delete('variant');
        if (options.length) request.searchParams.set('option_values', options.join(','));
        else request.searchParams.delete('option_values');
        return request.pathname + request.search;
      };
      info.renderProductInfo = async params => {
        this.lastRequest = params;
        info.abortController?.abort();
        const requestController = new AbortController();
        info.abortController = requestController;
        this.setBusy(true);
        this.setError(false);
        try {
          const response = await fetch(params.requestUrl, { signal: requestController.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Product request failed');
          const html = this.scopedDocument(await response.text());
          if (requestController.signal.aborted || !this.isConnected) return;
          info.pendingRequestUrl = null;
          params.callback(html);
          if (params.targetId) info.querySelector('#' + CSS.escape(params.targetId))?.focus();
          this.setBusy(false);
        } catch (error) {
          if (error.name === 'AbortError' || !this.isConnected) return;
          info.productForm?.toggleSubmitButton(true);
          this.setError(true);
        }
      };
      // Dawn normally suppresses this subscription when originalSection is set
      // (as in quick-add). Install a scoped equivalent for permanent LP blocks.
      info.fetchQuantityRules = async () => {
        const variant = info.productForm?.variantIdInput?.value;
        if (!variant || !info.quantityInput) return;
        this.quantityController?.abort();
        const controller = this.quantityController = new AbortController();
        const url = new URL(info.dataset.url, location.origin);
        url.searchParams.set('variant', variant);
        url.searchParams.set('section_id', this.dataset.parentSection);
        const spinner = info.querySelector('.quantity__rules-cart .loading__spinner');
        spinner?.classList.remove('hidden');
        try {
          const response = await fetch(url.pathname + url.search, { signal: controller.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Quantity request failed');
          const html = this.scopedDocument(await response.text());
          if (!controller.signal.aborted && this.isConnected && info.productForm?.variantIdInput?.value === variant) {
            info.updateQuantityRules(info.dataset.section, html);
            info.setQuantityBoundries();
          }
        } catch (error) {
          // Cart addition already succeeded. Never retry the cart submission.
          if (error.name !== 'AbortError') info.dispatchEvent(new CustomEvent('surutto:quantity-refresh-error', { bubbles: true }));
        } finally { if (this.quantityController === controller) spinner?.classList.add('hidden'); }
      };
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeCart?.();
        this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, () => info.fetchQuantityRules());
      }
    }
    scopedDocument(text) {
      const parsed = new DOMParser().parseFromString(text, 'text/html');
      const source = parsed.getElementById('NFProduct-' + this.dataset.instance);
      if (!source || source.dataset.productId !== this.dataset.productId) throw new Error('Product block missing from response');
      // Dawn uses the first variant-selects/media-gallery in its response.
      // A document containing ONLY this product prevents cross-product updates.
      const result = document.implementation.createHTMLDocument('');
      result.body.appendChild(result.importNode(source, true));
      return result;
    }
    setBusy(busy) {
      this.setAttribute('aria-busy', String(busy));
      this.querySelector('[data-nf-dawn-wishlist]')?.toggleAttribute('hidden', busy);
    }
    setError(show) {
      this.querySelector('[data-nf-dawn-error]')?.toggleAttribute('hidden', !show);
      if (show) this.setAttribute('aria-busy', 'false');
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.info?.abortController?.abort();
      this.quantityController?.abort();
      this.unsubscribeCart?.();
      this.unsubscribeCart = null;
      if (this.info?.__suruttoBridge === this) {
        this.info.buildRequestUrlWithParams = this.original.build;
        this.info.renderProductInfo = this.original.render;
        this.info.fetchQuantityRules = this.original.quantity;
        delete this.info.__suruttoBridge;
      }
    }
  }
  customElements.define(TAG, SuruttoNFDawnBridge);
})();


(() => {
  const tag = 'surutto-growave-featured-wishlist';
  if (customElements.get(tag)) return;
  class SuruttoGrowaveFeaturedWishlist extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.scope = this.closest('product-info, [data-nf-product]') || this.closest('.shopify-section');
      this.host = this.querySelector('[data-sg-widget]');
      if (!this.scope || !this.host) return;
      this.productCache = new Map();
      this.pending = new Map();
      this.epoch = 0;
      const update = () => {
        if (this.queued) return;
        this.queued = true;
        queueMicrotask(() => { this.queued = false; if (this.isConnected) this.sync(); });
      };
      this.scope.addEventListener('change', update, { signal: this.abort.signal });
      this.scope.addEventListener('variant:change', update, { signal: this.abort.signal });
      this.observer = new MutationObserver(update);
      this.observer.observe(this.scope, { subtree: true, childList: true, attributes: true, attributeFilter: ['value', 'data-product-id', 'data-url'] });
      update();
    }
    async sync() {
      const epoch = ++this.epoch;
      const source = this.scope.matches('product-info, [data-nf-product]') ? this.scope : this.scope.querySelector('product-info, [data-nf-product]');
      const form = this.scope.querySelector('.nf-product-form') || this.scope.querySelector('form[data-type="add-to-cart-form"]') || this.scope.querySelector('form[action*="/cart/add"]');
      const input = form?.querySelector('[name="id"]');
      const variantId = input?.value || '';
      if (!/^\d+$/.test(variantId)) { this.clear(); return; }
      let productId = source?.getAttribute('data-product-id') || '';
      if (!/^\d+$/.test(productId)) {
        const detailsLink = this.scope.querySelector('.product__view-details[href], a.full-unstyled-link[href*="/products/"], a[href*="/products/"]');
        const productUrl = source?.getAttribute('data-url') || detailsLink?.getAttribute('href');
        let endpoint;
        try {
          const url = new URL(productUrl || '', location.origin);
          if (url.origin !== location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) { this.clear(); return; }
          endpoint = url.pathname.replace(/\/$/, '') + '.js';
        } catch (_) { this.clear(); return; }
        // Older Dawn versions expose the product URL instead of its ID.
        // Read only that product's public metadata; never send cart/wishlist requests here.
        let item = this.productCache.get(endpoint);
        if (!item) {
          this.clear();
          if (!this.pending.has(endpoint)) {
            const request = fetch(endpoint, { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: this.abort.signal })
              .then(response => { if (!response.ok) throw new Error('Product unavailable'); return response.json(); })
              .then(data => { this.productCache.set(endpoint, data); return data; });
            this.pending.set(endpoint, request);
          }
          try { item = await this.pending.get(endpoint); }
          catch (_) { if (epoch === this.epoch && this.isConnected) this.clear(); return; }
        }
        if (epoch !== this.epoch || !this.isConnected) return;
        if (!item.variants?.some(variant => String(variant.id) === variantId)) { this.clear(); return; }
        productId = String(item.id);
      }
      if (!/^\d+$/.test(productId)) { this.clear(); return; }
      let widget = this.host.querySelector('.gw-wl-add-to-wishlist-placeholder');
      if (!widget || widget.getAttribute('data-gw-product-id') !== productId) {
        widget = document.createElement('div');
        widget.className = 'gw-wl-add-to-wishlist-placeholder';
        widget.setAttribute('data-gw-product-id', productId);
        widget.setAttribute('data-gw-variant-id', variantId);
        widget.setAttribute('data-gw-icon-only', 'false');
        widget.style.display = 'block';
        // Growave's app embed observes inserted placeholders and mounts the real widget.
        this.host.replaceChildren(widget);
      } else if (widget.getAttribute('data-gw-variant-id') !== variantId) {
        widget.setAttribute('data-gw-variant-id', variantId);
      }
    }
    clear() {
      if (this.host?.childNodes.length) this.host.replaceChildren();
    }
    disconnectedCallback() {
      ++this.epoch;
      this.abort?.abort();
      this.abort = null;
      this.observer?.disconnect();
    }
  }
  customElements.define(tag, SuruttoGrowaveFeaturedWishlist);
})();


  } catch(e) { console.error(e); }
})();
})();
